let ProductPage = (function () {

    let formful_form_id = ""

    /**
     * @typedef {Object} ProductData
     * @property {string} type - Kategoria/typ produktu (np. "T-Shirt", "Electronics")
     * @property {string} handle - Unikalny identyfikator produktu używany w URL
     * @property {string} realization_time_product_handle
     */

    /**
     *
     * @returns {boolean}
     */
    function isPhotoEditorOn()
    {
        if (typeof PhotoEditor !== 'undefined') {
            return true;
        }
        return false;
    }

    /**
     *
     * @returns {boolean}
     */
    function isPhotoEditorEnabled()
    {
        if (isPhotoEditorOn()) {
            return PhotoEditor.isEditorEnabled();
        }
        return false;
    }

    /**
     * @returns {ProductData}
     */
    function getProductData()
    {
        return window.productData;
    }

    function initMediaCarousel()
    {
        const wrapper = document.querySelector('.thumbnails-wrapper');

        if(!wrapper) return;


        const thumbs = document.querySelectorAll('.media__thumb');
        const prevBtn = document.querySelector('.thumb-prev');
        const nextBtn = document.querySelector('.thumb-next');
        const lightbox = document.getElementById('imageLightbox');
        const lightboxImg = lightbox?.querySelector('.lightbox-image');
        let currentIndex = 0;
        const images = Array.from(thumbs).map(t => t.dataset.mediaUrl);
        const scrollAmount = 135; // szerokość miniatury + gap

        // Przewijanie miniaturek
        function updateButtons() {
            const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
            prevBtn.disabled = wrapper.scrollLeft <= 0;
            nextBtn.disabled = wrapper.scrollLeft >= maxScroll;
        }

        prevBtn?.addEventListener('click', () => {
            wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
            setTimeout(updateButtons, 300);
        });

        nextBtn?.addEventListener('click', () => {
            wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
            setTimeout(updateButtons, 300);
        });

        wrapper?.addEventListener('scroll', updateButtons);
        updateButtons();

        // Lightbox
        thumbs.forEach((thumb, index) => {
            thumb.addEventListener('click', () => {
                currentIndex = index;
                openLightbox();
                thumbs.forEach(t => t.classList.remove('active'));
                thumb.classList.add('active');
            });
        });

        function openLightbox() {
            lightboxImg.src = images[currentIndex];
            lightbox.style.display = 'flex';
            document.body.style.overflow = 'hidden';
        }

        lightbox.addEventListener('click', (e) => {
            if (e.target === lightbox) {   // kliknięto w tło, nie w treść
                lightbox.style.display = 'none';
                document.body.style.overflow = '';
            }
        });

        lightbox?.querySelector('.lightbox-close').addEventListener('click', () => {
            lightbox.style.display = 'none';
            document.body.style.overflow = '';
        });

        lightbox?.querySelector('.lightbox-prev').addEventListener('click', () => {
            currentIndex = (currentIndex - 1 + images.length) % images.length;
            lightboxImg.src = images[currentIndex];
            updateActiveThumb();
        });

        lightbox?.querySelector('.lightbox-next').addEventListener('click', () => {
            currentIndex = (currentIndex + 1) % images.length;
            lightboxImg.src = images[currentIndex];
            updateActiveThumb();
        });

        function updateActiveThumb() {
            thumbs.forEach((t, i) => {
                t.classList.toggle('active', i === currentIndex);
            });
        }

        // Klawisze
        document.addEventListener('keydown', (e) => {
            if (lightbox.style.display === 'flex') {
                if (e.key === 'Escape') {
                    lightbox.style.display = 'none';
                    document.body.style.overflow = '';
                }
                if (e.key === 'ArrowLeft') lightbox.querySelector('.lightbox-prev').click();
                if (e.key === 'ArrowRight') lightbox.querySelector('.lightbox-next').click();
            }
        });


    }

    function openModal(__modal)
    {
        __modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
    }

    function closeModal(__modal)
    {
        __modal.style.display = 'none';
        document.body.style.overflow = '';
    }

    function initChooseMaterialPopup()
    {
        let modal = document.querySelector('[data-material-modal]');
        if(!modal) return;

        let modalTrigger = document.querySelector('[data-material-modal-trigger]');
        let modalCloses = document.querySelectorAll('[data-material-modal-close]');
        let destinationDropdown = modal.querySelector('.materials-destination-dropdown');
        let destinationSelectedText = modal.querySelector('.materials-destination-selected-text');
        let destinationOptions = modal.querySelectorAll('.dropdown-option');
        let materialOptions = document.querySelectorAll('.materials-selector__item');




        if (modalTrigger) {
            modalTrigger.addEventListener('click', function() {
                openModal(modal);
            });
        }

        modalCloses.forEach(function(closeBtn) {
            closeBtn.addEventListener('click', function() {
                closeModal(modal);
            });
        });

        destinationOptions.forEach(function(option) {
            let chosen_destination = option.innerText.trim();
            let is_no_selection = option.classList.contains('dropdown-option-no-selection');
            option.addEventListener('click', function() {

                modal.querySelectorAll('[data-material-destinations]').forEach(function(element){
                    let destinations = element.dataset.materialDestinations;
                    if(is_no_selection || destinations.split(',').includes(chosen_destination))
                        element.classList.remove("hidden");
                    else
                        element.classList.add("hidden");
                });
                selectFirstAvailableMaterialDestination();
                destinationSelectedText.textContent = chosen_destination;
                destinationDropdown.classList.remove('open');
            });
        });

        // Obsługa wyboru materiału
        materialOptions.forEach(function(option) {

            let materialName = option.dataset.materialName;

            option.addEventListener('click', function() {
                option.classList.add('is-active');

                //Custom.updateProductVariantId(selected_variant_id);

                materialOptions.forEach(function(other_option) {
                    if(other_option.dataset.materialName !== materialName)
                        other_option.classList.remove('is-active');
                });
                modal.querySelectorAll('.material-details__container').forEach(function(material_details){
                    material_details.classList.toggle("hidden", !(material_details.dataset.materialName === materialName));
                });
            });


        });

        const selectBtn = modal.querySelector('[data-select-material]');

        selectBtn.addEventListener('click', function() {

            let option = document.querySelector('.materials-selector__item.is-active');
            let materialName = option.dataset.materialName;
            let selected_variant_id = option.dataset.variantId;

            let trigger = document.querySelector('.material-selector-trigger');
            trigger.dataset.currentMaterial = materialName;
            trigger.dataset.currentVariantId = selected_variant_id;

            let triggerText = document.querySelector('.material-name');
            if (triggerText) {
                triggerText.textContent = materialName;
            }

            if(isPhotoEditorOn())
                updateTilingSettings(option);

            Custom.updateProductVariantId(selected_variant_id);

            updatePrice();

            closeModal(modal);

        });

/*
        let selected_product_variant = getSelectedProductVariant();

        selected_variant_id = selected_product_variant.id;

        let option = document.querySelector('.materials-selector__item.is-active');
        let materialName = option.dataset.materialName;
        let selected_variant_id = option.dataset.variantId;

        let trigger = document.querySelector('.material-selector-trigger');
        trigger.dataset.currentMaterial = materialName;
        trigger.dataset.currentVariantId = selected_variant_id;

        let triggerText = document.querySelector('.material-name');
        if (triggerText) {
            triggerText.textContent = materialName;
        }

        if(isPhotoEditorOn())
            updateTilingSettings(option);
*/

    }

    function selectFirstAvailableMaterialDestination()
    {
        let materialOptions = document.querySelectorAll('.materials-selector__item');

        let is_active_hidden = false;
        if(materialOptions)
        {
            materialOptions.forEach(function(option)
            {
                if(option.classList.contains("is-active") && option.classList.contains("hidden"))
                {
                    is_active_hidden = true;
                    option.classList.remove("is-active")
                }
            });
            materialOptions.forEach(function(option)
            {
                if(!option.classList.contains("hidden"))
                {
                    if(is_active_hidden)
                    {
                        option.classList.add("is-active");
                        is_active_hidden = false;
                    }

                    if(option.classList.contains("is-active"))
                        Custom.dispatchEvent(option, 'click');

                }

            });

        }
    }

    function onSelectColorVariant(selected_variant_id, selected_image_id)
    {
        let img_in_gallery = document.querySelector('[data-media-select="' + selected_image_id + '"]');
        if(img_in_gallery)
            Custom.dispatchEvent(img_in_gallery, 'click');

        Custom.updateProductVariantId(selected_variant_id);

        updatePrice();
    }

    function initChooseVariant()
    {

        let product_variant_dropdown = document.querySelector('.product-variant-dropdown');

        if(product_variant_dropdown)
        {
            let product_variant_selected_text = product_variant_dropdown.querySelector('.product-variant-selected-text');
            let product_variant_options = product_variant_dropdown.querySelectorAll('.dropdown-option');

            product_variant_options.forEach(function(option) {

                let chosen_destination = option.innerText.trim();
                let selected_variant_id = option.dataset.variantId;

                option.addEventListener('click', function() {


                    product_variant_selected_text.textContent = chosen_destination;
                    product_variant_dropdown.classList.remove('open');

                    Custom.updateProductVariantId(selected_variant_id);

                    updatePrice();

                });

            });
        }

    }

    function initChooseColor()
    {

        let color_options = document.querySelectorAll('.colors-selector__item');
        let selectedColorText = document.getElementById('selectedColorText');

        color_options.forEach(function(option) {

            let selected_variant_id = option.dataset.variantId;
            let selected_color_name = option.dataset.colorName;
            let selected_image_id = option.dataset.mediaId;

            option.addEventListener('click', function() {

                option.classList.add('is-active');

                if(selectedColorText)
                    selectedColorText.innerText = selected_color_name.trim();

                onSelectColorVariant(selected_variant_id, selected_image_id);


                color_options.forEach(function(other_option) {
                    if(other_option.dataset.colorName !== selected_color_name)
                        other_option.classList.remove('is-active');
                });
            });

            if(option.classList.contains("is-active"))
                onSelectColorVariant(selected_variant_id, selected_image_id);

        });
    }

    function updateTilingSettings(__option)
    {

        if(__option === undefined)
            __option = document.querySelector('[data-material-is-current="1"]');

        let roll_width_value = __option.dataset.materialRollWidthValue;
        let roll_width_unit = __option.dataset.materialRollWidthUnit;

        let min_roll_width_value = __option.dataset.materialMinRollWidthValue;
        let min_roll_width_unit = __option.dataset.materialMinRollWidthUnit;

        let overlap_h_value = __option.dataset.materialOverlapHValue;
        let overlap_h_unit = __option.dataset.materialOverlapHUnit;

        PhotoEditor.setTilingSettings(roll_width_value, roll_width_unit, min_roll_width_value, min_roll_width_unit, overlap_h_value, overlap_h_unit);

    }

    function openPreviewModal(__unique_id)
    {
        const modal = document.querySelector('[data-product-preview-modal="' + __unique_id + '"]');

        openModal(modal);

        if(isPhotoEditorOn())
        {
            let canvas = PhotoEditor.getDetailedPreview();
            document.querySelector('.modal-content-image').replaceChildren(canvas);
        }
    }

    function closePreviewModal(__unique_id)
    {
        const modal = document.querySelector('[data-product-preview-modal="' + __unique_id + '"]');
        closeModal(modal);
        return false;
    }

    async function downloadPreview(downloadPreviewBtn)
    {
        if(isPhotoEditorEnabled())
            await downloadProductPreview(downloadPreviewBtn);
        else
            await downloadTexture(downloadPreviewBtn);
    }

    // Wspólna funkcja do określania nazwy pliku
    function getFilenameFromData(patternName, textureFilename, textureUrl) {
        if (patternName && patternName.trim() !== '') {
            return patternName;
        }

        if (textureFilename) {
            return textureFilename.replace(/\.[^/.]+$/, "");
        }

        const urlParts = textureUrl.split('/');
        const fileNameFromUrl = urlParts[urlParts.length - 1].split('?')[0];
        return fileNameFromUrl.replace(/\.[^/.]+$/, "");
    }

// Wspólna funkcja pobierania
    function triggerDownload(blob, filename) {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
    }

// Pobieranie podglądu z canvas
    async function downloadProductPreview(downloadBtn) {
        const { patternName, textureFilename, textureUrl } = downloadBtn.dataset;

        const filename = getFilenameFromData(patternName, textureFilename, textureUrl);
        const canvas = PhotoEditor.getDetailedPreview();
        const file = await canvasToFile(canvas);

        const extension = '.' + (file.type.split('/')[1] || 'png');
        triggerDownload(file, filename + extension);
    }

// Pobieranie tekstury z URL
    async function downloadTexture(downloadBtn) {
        const { patternName, textureFilename, textureUrl } = downloadBtn.dataset;

        const filename = getFilenameFromData(patternName, textureFilename, textureUrl);

        // Wyciągnij rozszerzenie z URL
        const match = textureUrl.match(/\.(jpg|jpeg|png|webp|tiff|bmp|pdf)(\?.*)?$/i);
        const extension = match ? '.' + match[1].toLowerCase() : '.jpg';

        try {
            const response = await fetch(textureUrl);
            if (!response.ok) throw new Error('Network response was not ok');

            const blob = await response.blob();
            triggerDownload(blob, filename + extension);
        } catch (error) {
            console.error('Błąd pobierania:', error);
            alert('Nie udało się pobrać tekstury');
        }
    }

    function updateM2Total() {
        const widthElement = document.querySelector('[data-toggle="ctw-width"]');
        const heightElement = document.querySelector('[data-toggle="ctw-height"]');
        const totalElement = document.querySelector('[data-content="m2_total"]');

        if (!widthElement || !heightElement || !totalElement) return;

        const width_in_cm = parseFloat(widthElement.value) || 0;
        const height_in_cm = parseFloat(heightElement.value) || 0;

        const total = Math.ceil(width_in_cm * height_in_cm / 10000); // zakładając że wartości są w cm, a chcesz m²
        totalElement.textContent = total;

        const quantityInput = document.querySelector('[data-quantity-input]');
        if(quantityInput)
            quantityInput.value = total;


    }

    function initM2TotalObserver()
    {
        // Obserwuj zmiany w obu elementach
        const observer = new MutationObserver(updateM2Total);

        const widthElement = document.querySelector('[data-content="cte-width-with-safe-zone"]');
        const heightElement = document.querySelector('[data-content="cte-height-with-safe-zone"]');

        if (widthElement && heightElement) {
            observer.observe(widthElement, { childList: true, subtree: true, characterData: true });
            observer.observe(heightElement, { childList: true, subtree: true, characterData: true });

            // Oblicz początkową wartość
            updateM2Total();
        }
    }

    function initGrayscaleButton()
    {
        let grayscale_buttons = document.querySelectorAll('.grayscale-btn');
        if(grayscale_buttons)
        {
            grayscale_buttons.forEach(function(__grayscale_button){
                __grayscale_button.addEventListener('click', function(e) {
                    let isGrayscale = __grayscale_button.value === 'grayscale';
                    setTimeout(() => {
                        __grayscale_button.value = isGrayscale ? 'none' : 'grayscale';
                    }, 0);
                });
            });
        }
    }

    function getRealizationTimeDropdownElement() {
        return document.getElementById('realizationTimeDropdown');
    }


    function getSelectedRealizationTimeElement()
    {
        let dropdown = getRealizationTimeDropdownElement();
        if(dropdown)
            return dropdown.querySelector('#selectedRealizationTimeText');
        else return null;



    }

    /**
     * pobiera nazwę wybranego terminu realizacji
     * @returns {*}
     */
    function getSelectedRealizationTimeName()
    {
        let selectedElement = getSelectedRealizationTimeElement();
        if(selectedElement)
            return selectedElement.innerText;
        else
            return "";
    }

    function selectRealizationTime(text) {

        let dropdown = getRealizationTimeDropdownElement();
        let selectedElement = getSelectedRealizationTimeElement();

        selectedElement.textContent = text;
        dropdown.classList.remove('open');

        updatePrice();
    }

    async function updateLineProperties()
    {
        if(isPhotoEditorOn())
            await updatePhotoEditorRelatedLineProperties();

        updatePersonalizationRelatedLineProperties();

        let realization_time_name = getSelectedRealizationTimeName();
        if(realization_time_name)
            document.getElementById("prop_realization_time").value = realization_time_name;

        removeUnnecessaryLineProperties();

    }

    function updatePersonalizationRelatedLineProperties()
    {
        if(isPersonalizationOn())
        {
            document.getElementById("prop_personalization_on").checked = true;
        }

        if(isPersonalizationShapeOn())
        {
            document.getElementById("prop_personalization_shape").checked = true;
            document.getElementById("prop_personalization_shape_description").value = getPersonalizationShapeTextareaElement().value;
            copyInputFiles(getPersonalizationShapeFileInput(), document.getElementById("prop_personalization_shape_attachments"));
        }

        if(isPersonalizationPatternOn())
        {
            document.getElementById("prop_personalization_pattern").checked = true;
            document.getElementById("prop_personalization_pattern_description").value = getPersonalizationPatternTextareaElement().value;
            copyInputFiles(getPersonalizationPatternFileInput(), document.getElementById("prop_personalization_pattern_attachments"));
        }





    }

    function removeUnnecessaryLineProperties()
    {
        let is_rolls_editor = false;
        let is_on_size_editor = false;

        if(isPhotoEditorOn())
        {
            if( PhotoEditor.isPanelEditor() )
                is_rolls_editor = true;
            else
                is_on_size_editor = true;
        }

        if(!is_rolls_editor)
            document.getElementById("prop_selected_rolls").remove();

        if(!is_on_size_editor)
        {
            document.getElementById("prop_selection_size").remove();
        }

        if(!is_on_size_editor || isPersonalizationOn())
        {
            document.getElementById("prop_photo_size").remove();
            document.getElementById("prop_selection_x").remove();
            document.getElementById("prop_selection_y").remove();
            document.getElementById("prop_filter").remove();
            document.getElementById("prop_horizontal_flip").remove();
            document.getElementById("prop_vertical_flip").remove();
            document.getElementById("prop_rotation").remove();
            document.getElementById("prop_scale").remove();
        }

        if(isPersonalizationOn() || !isPhotoEditorOn())
            document.getElementById("prop_detailed_preview_canvas").remove();

        if(!isPersonalizationShapeOn())
            document.getElementById("prop_personalization_shape_description").remove();

        if(!isPersonalizationPatternOn())
            document.getElementById("prop_personalization_pattern_description").remove();

        let realization_time_name = getSelectedRealizationTimeName();
        if(!realization_time_name)
            document.getElementById("prop_realization_time").remove();


    }

    async function updatePhotoEditorRelatedLineProperties()
    {

        let configurator = PhotoEditor.getConfigurator();

        let data = configurator.getData();
        let editor_data = data.editor_data;
        let editor_data_obj = JSON.parse(editor_data);
        let forms = editor_data_obj.forms;


        if( PhotoEditor.isPanelEditor() )
        {
            let panels = [];

            forms.forEach(function(__form){
                panels.push(__form.id);
            });

            document.getElementById("prop_selected_rolls").value = panels.join(", ");

        }
        else
        {

            let unit = editor_data_obj.unit.symbol;

            let width = parseFloat(editor_data_obj.size.width).toFixed(3);
            let height = parseFloat(editor_data_obj.size.height).toFixed(3);

            width = Custom.convertToUnit(width, unit, 'cm');
            height = Custom.convertToUnit(height, unit, 'cm');

            document.getElementById("prop_photo_size").value = `${width} × ${height} cm`;

            if(isPhotoEditorEnabled())
            {
                document.getElementById("prop_scale").value = PhotoEditor.getScaleValue();

                let editor_data_image = editor_data_obj.background;
                if(editor_data_image && editor_data_image.type === 'foto')
                {
                    let transformation = editor_data_image.transformation;
                    if(transformation.filter){
                        let filter_result = transformation.filter;
                        if(transformation.filter_value !== null)
                            filter_result += " " + transformation.filter_value;
                        document.getElementById("prop_filter").value = filter_result;
                    }
                    else
                        document.getElementById("prop_filter").remove();

                    if(transformation.horizontal_flip)
                        document.getElementById("prop_horizontal_flip").value = 'yes';
                    else
                        document.getElementById("prop_horizontal_flip").remove();

                    if(transformation.vertical_flip)
                        document.getElementById("prop_vertical_flip").value = 'yes';
                    else
                        document.getElementById("prop_vertical_flip").remove();

                    if(transformation.rotation)
                        document.getElementById("prop_rotation").value = transformation.rotation;
                    else
                        document.getElementById("prop_rotation").remove();

                }

                editor_data_obj.objects.forEach(function(object){

                    if(object.id === 'workspace')
                    {

                        let left = parseFloat(object.left).toFixed(3);
                        left = Custom.convertToUnit(left, unit, 'cm');

                        document.getElementById("prop_selection_x").value = `${left} cm`;

                        let top = parseFloat(object.top).toFixed(3);
                        top = Custom.convertToUnit(top, unit, 'cm');

                        document.getElementById("prop_selection_y").value = `${top} cm`;

                    }
                });
            }

            editor_data_obj.objects.forEach(function(object){

                if(object.id === 'workspace')
                {
                    let width = parseFloat(object.width).toFixed(3);
                    let height = parseFloat(object.height).toFixed(3);

                    width = Custom.convertToUnit(width, unit, 'cm');
                    height = Custom.convertToUnit(height, unit, 'cm');

                    document.getElementById("prop_selection_size").value = `${width} × ${height} cm`;

                }
            });



        }

        const fileInput = document.querySelector('input[type="file"][name="properties[preview_file]"]');
        const dataTransfer = new DataTransfer();
        const fileInput2 = document.querySelector('input[type="file"][name="properties[detailed_preview_file]"]');
        const dataTransfer2 = new DataTransfer();

        let file, file2;

        if(isPhotoEditorEnabled())
        {
            let canvas = PhotoEditor.getSimplePreview();
            file = await canvasToFile(canvas);

            let canvas2 = PhotoEditor.getDetailedPreview();
            file2 = await canvasToFile(canvas2);
        }
        else
        {
            let url = getScaledTextureUrl();
            file = await urlToFile(url);
        }

        if(file)
        {
            dataTransfer.items.add(file);
            fileInput.files = dataTransfer.files;
        }

        if(file2)
        {
            dataTransfer2.items.add(file2);
            fileInput2.files = dataTransfer2.files;
        }

    }

    async function urlToFile(url, filename) {
        const res = await fetch(url, { mode: "cors" }); // może się wywalić, jeśli brak CORS
        if (!res.ok) throw new Error(`Fetch failed: ${res.status} ${res.statusText}`);

        const blob = await res.blob();
        const contentType = blob.type || res.headers.get("content-type") || "application/octet-stream";

        // jeśli nie podasz filename, spróbujemy wyciągnąć z URL
        const name =
            filename ||
            decodeURIComponent(new URL(url, location.href).pathname.split("/").pop() || "file");

        return new File([blob], name, { type: contentType, lastModified: Date.now() });
    }

    const canvasToFile = (canvas) => {
        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                resolve(new File([blob], 'design.png', { type: 'image/png' }));
            }, 'image/png');
        });
    };

    function getSelectedProductVariant()
    {
        const variantId = document.querySelector('[name="id"]').value;
        const productJson = JSON.parse(
            document.querySelector('[data-product-json]').textContent
        );

        return productJson.variants.find(v => v.id == variantId);
    }

    async function updatePrice()
    {


        let product_row = document.querySelector('.wallpaper_cost [data-product-price]');
        let realization_time_row = document.querySelector('.realization_time_cost');
        let total_price_row = document.querySelector('.total_cost');

        let price_addon_count = 0;

        let selected_product_variant = getSelectedProductVariant();


        let quantity = getQuantity();
        let selected_product_variant_unit_price = selected_product_variant.price / 100;

        let selected_product_variant_unit_price_formatted = Custom.formatMoney(selected_product_variant_unit_price);


        let selected_product_variant_price = quantity * selected_product_variant_unit_price;

        let product_price_formatted = Custom.formatMoney(selected_product_variant_price);

        product_row.innerText = product_price_formatted;

        let total_price = selected_product_variant_price;

        let realization_time_addon_variant = await getRealizationTimeAddonProductVariant();
        if(realization_time_addon_variant)
        {
            realization_time_row.hidden = false;

            let realization_time_addon_variant_price = quantity * realization_time_addon_variant.price / 100;
            let realization_time_addon_variant_price_formatted = Custom.formatMoney(realization_time_addon_variant_price);

            document.getElementById('realization_time_additional_price').innerText = '+' + realization_time_addon_variant_price_formatted;

            total_price += realization_time_addon_variant_price;

            price_addon_count++;

        }
        else
        {
            realization_time_row.hidden = true;
        }

        document.querySelectorAll('[data-product-unit-price]').forEach(function(item){
            item.innerText = selected_product_variant_unit_price_formatted;
        });

        document.querySelectorAll('[data-product-price]:not([data-product-unit-price])').forEach(function(item){
            item.innerText = product_price_formatted;
        });




        let total_price_formatted = Custom.formatMoney(total_price);

        document.getElementById('total_price').innerText = total_price_formatted;

        if(price_addon_count > 0)
        {
            total_price_row.hidden = false;
        }
        else
        {
            total_price_row.hidden = true;
        }

    }

    /**
     *
     * @returns {boolean}
     */
    function validate()
    {
        let is_valid = true;
        if (!validateQuantityInputs()) is_valid = false;
        return is_valid;
    }

    /**
     *
     * @returns {boolean}
     */
    function validate()
    {
        let is_valid = true;
        if (!validateQuantityInputs()) is_valid = false;
        return is_valid;
    }

    /**
     * @returns {boolean}
     */
    function validateQuantityInputs()
    {

        let is_valid = true;

        let firstInvalid = null;


        document.querySelectorAll('.quantity__input').forEach(function(__input){
            if(Custom.isElementVisible(__input) && !__input.checkValidity())
                is_valid = false;
                if (!firstInvalid) firstInvalid = __input;
        });

        if (!is_valid && firstInvalid) {
            firstInvalid.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            firstInvalid.focus({ preventScroll: true });
        }

        return is_valid;
    }

    async function addToCart(e) {

        if (!validate()) return false;

        e.preventDefault();

        const form = document.querySelector(".shopify-product-form");
        if (!form) return false;

        await updateLineProperties();

        const unique_id = Date.now() + "_" + Math.random().toString(36).substr(2, 9);
        await addRealizationTimeAddonProduct(unique_id);

        // usuń poprzednie pole, żeby nie dublować
        const prev = form.querySelector('input[name="properties[_linked_group]"]');
        if (prev) prev.remove();

        // dodaj ukryte pole
        const uniqueField = document.createElement("input");
        uniqueField.type = "hidden";
        uniqueField.name = "properties[_linked_group]";
        uniqueField.value = unique_id;
        form.appendChild(uniqueField);

        // 🔥 to jest kluczowe: NIE używaj form.submit()
        if (typeof form.requestSubmit === "function") {
            // requestSubmit odpala normalne eventy submit -> Pixel / integracje mają szansę zadziałać
            form.requestSubmit();
        } else {
            // fallback dla starszych przeglądarek
            const tmpBtn = document.createElement("button");
            tmpBtn.type = "submit";
            tmpBtn.style.display = "none";
            form.appendChild(tmpBtn);
            tmpBtn.click();
            tmpBtn.remove();
        }

        return true;
    }

    /**
     *
     * @returns {*}
     */
    function getQuantity()
    {
        return document.querySelector('[data-quantity-input]').value;
    }

    async function getRealizationTimeAddonProductVariant()
    {
        let addonProductHandle = getProductData().realization_time_product_handle;

        if(addonProductHandle)
        {
            let product_type = getProductData().type;
            let realization_time = getSelectedRealizationTimeName();
            let material = getSelectedMaterialName();
            let quantity = getQuantity();

            const addonVariant = await findVariant(addonProductHandle, product_type, realization_time, material);

            if(addonVariant)
            {
                let isAvailable = await checkRealizationTimeAddonVariantAvailability(addonVariant);

                if (isAvailable) {
                    return addonVariant;
                }
                else
                {
                    console.log("Znaleziono wariant produktu o uchwycie " + addonProductHandle + " i opcjach: " + [product_type, realization_time, material].join(', ') + " ale jest niedostępny");
                }
            }
            else
            {
                console.log("Nie znaleziono wariantu produktu o uchwycie " + addonProductHandle + " i opcjach: " + [product_type, realization_time, material].join(', '))
            }


        }
        else
        {
            console.log("brak uchwytu do produktu dopłaty do terminu realizacji - sprawdź czy ustawiono go w metapolach sklepu i czy produkt jest dostepny");
        }
        return null;
    }

    async function addRealizationTimeAddonProduct(__unique_id) {


        let addonProductHandle = getProductData().realization_time_product_handle;

        if(addonProductHandle)
        {
            let quantity = document.querySelector('[data-quantity-input]').value;

            let addonVariant = await getRealizationTimeAddonProductVariant();

            if(addonVariant)
            {
                let addonVariantId = addonVariant.id;
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: addonVariantId,
                        quantity: quantity,
                        properties: {
                            '_linked_group': __unique_id, // Unikalny identyfikator żeby dodał się jako osobna pozycja
                            'Dodane automatycznie': 'Tak'
                        }
                    }),
                });

                const data = await response.json();

            }
        }
        else
        {
            console.log("brak uchwytu do produktu dopłaty do terminu realizacji - sprawdź czy ustawiono go w metapolach sklepu i czy produkt jest dostepny");
        }
    }

    async function findVariant(productHandle, option1, option2, option3 = null) {

        const response = await fetch(
            `${Shopify.routes.root}products/${productHandle}.js`
        );

        const product = await response.json();

        const variant = product.variants.find(v => {
            return v.option1 === option1 &&
                v.option2 === option2 &&
                (!option3 || v.option3 === option3);
        });

        return variant ? variant : null;
    }

    async function checkRealizationTimeAddonVariantAvailability(variant) {

        //let variantId = variant.id;

        //const response = await fetch(`/variants/${variantId}.js`);
        //const variant = await response.json();

        const reallyAvailable = variant.available &&
            (variant.inventory_management !== 'shopify' ||
                variant.inventory_quantity > 0 ||
                variant.inventory_policy === 'continue');

        const hasValidPrice = variant.price > 0;

        return reallyAvailable && hasValidPrice;
    }

    function initAddToCartButton() {
        const btn =
            document.querySelector('[name="add"]') ||
            document.querySelector('.btn-cart') ||
            document.querySelector('button[data-action="add-to-cart"]') ||
            document.querySelector('[type="submit"]');

        if (!btn) return;

        let lock = false;

        btn.addEventListener("click", async (e) => {

            if (!validate())
            {
                e.preventDefault();
                return false;
            }

            if (lock) return;

            lock = true;
            btn.disabled = true;

            const ok = await addToCart(e);

            if (!ok) {
                btn.disabled = false;
                lock = false;
                return;
            }

            // jeśli submit pójdzie -> strona przeładuje się i tak
        }, { capture: true });
    }

    function getWidthElement()
    {
        return document.querySelector('[name="width"]');
    }

    function getHeightElement()
    {
        return document.querySelector('[name="height"]');
    }

    function getScaleElement()
    {
        return document.querySelector('[data-toggle="ctw-background-scale"]');
    }

    function getMaterialNameElement()
    {
        return document.querySelector(".material-name")
    }

    /**
     * pobiera nazwę wybranego materiału
     * @returns {*}
     */
    function getSelectedMaterialName()
    {
        let material_name = getMaterialNameElement();
        return material_name.innerText;
    }

    function getPatternName()
    {
        var product_data = getProductData();
        return product_data.pattern;
    }

    function isPersonalizationOn()
    {
        if(isPersonalizationShapeOn() || isPersonalizationPatternOn() || (isPhotoEditorOn() && !isPhotoEditorEnabled()))
            return true;
        return false;
    }

    /**
     * czy użytkownik wybrał personalizację "okna / drzwi / inny kształt ściany"
     * @returns {boolean|*}
     */
    function isPersonalizationShapeOn()
    {
        let checkbox = getPersonalizationShapeCheckboxElement();
        if(checkbox)
            return checkbox.checked;
        return false;
    }

    function getPersonalizationShapeCheckboxElement()
    {
        return document.querySelector('[name="personalization_shape"]');
    }

    function getPersonalizationShapeTextareaElement()
    {
        return document.getElementById("personalization_shape_description");
    }

    /**
     * czy użytkownik wybrał personalizację "modyfikacja koloru / wzoru"
     * @returns {boolean|*}
     */
    function isPersonalizationPatternOn()
    {
        let checkbox = getPersonalizationPatternCheckboxElement();
        if(checkbox)
            return checkbox.checked;
        return false;
    }

    function getPersonalizationPatternCheckboxElement()
    {
        return document.querySelector('[name="personalization_pattern"]');
    }

    function getPersonalizationPatternTextareaElement()
    {
        return document.getElementById("personalization_pattern_description");
    }

    function getSubmitFormButton()
    {
        return document.querySelector('.product__submit');
    }

    function getSendValuationSubmitButton()
    {
        return document.querySelector('.formful__button');
    }

    function getCostEstimateElement()
    {
        return document.querySelector('.cost_estimate');
    }

    function getSendValuationFormFormfulSection()
    {
        let formful_wrapper = getSendValuationForm().parentNode;
        return formful_wrapper.parentNode;
    }

    function getSendValuationForm()
    {
        return document.getElementById('formful__form_' + formful_form_id);
    }

    function initSendValuationRequestForm()
    {

        const config = JSON.parse(document.getElementById('formful-send-valuation-request-config').textContent);

        formful_form_id = config.formful_form_id;

        if(!formful_form_id) return;

        let first_last_name_field_id = config.first_last_name_field_id;
        let email_field_id = config.email_field_id;

        let width_field_id = config.width_field_id;
        let height_field_id = config.height_field_id;
        let scale_field_id = config.scale_field_id;


        let pattern_field_id = config.pattern_field_id;

        let material_field_id = config.material_field_id;
        let realization_time_field_id = config.realization_time_field_id;

        let personalization_shape_description_field_id = config.personalization_shape_description_field_id;
        let personalization_shape_files_field_id = config.personalization_shape_files_field_id;

        let personalization_pattern_description_field_id = config.personalization_pattern_description_field_id;
        let personalization_pattern_files_field_id = config.personalization_pattern_files_field_id;


        let formful_form = getSendValuationForm();
        if(formful_form)
        {

            formful_form.parentNode.classList.add("product-page-formful-wrapper");
            getSendValuationFormFormfulSection().hidden = true;

            let submit_button = getSendValuationSubmitButton();
            if(submit_button)
            {
                submit_button.classList.add("btn", "btn--neutral");

                // Utwórz nowy listener, który wykona Twój kod przed resztą
                submit_button.addEventListener('click', function preClickHandler(e) {
                    // 1️⃣ Twój kod
                    let formful_form_width_input = document.getElementById('field-' + width_field_id);
                    if(formful_form_width_input)
                        formful_form_width_input.value = getWidthElement().value;

                    let formful_form_height_input = document.getElementById('field-' + height_field_id);
                    if(formful_form_height_input)
                        formful_form_height_input.value = getHeightElement().value;

                    if(PhotoEditor.isEditorEnabled())
                    {

                        let formful_form_scale_input = document.getElementById('field-' + scale_field_id);
                        if(formful_form_scale_input)
                            formful_form_scale_input.value = PhotoEditor.getScaleValue();

                    }

                    let formful_form_pattern_input = document.getElementById('field-' + pattern_field_id);
                    if(formful_form_pattern_input)
                        formful_form_pattern_input.value = getPatternName();

                    let formful_form_material_input = document.getElementById('field-' + material_field_id);
                    if(formful_form_material_input)
                        formful_form_material_input.value = getSelectedMaterialName();

                    let formful_personalization_shape_description_field = document.getElementById('field-' + personalization_shape_description_field_id);
                    if(formful_personalization_shape_description_field)
                        formful_personalization_shape_description_field.value = getPersonalizationShapeTextareaElement().value;

                    let formful_personalization_shape_files_input = document.getElementById('field-' + personalization_shape_files_field_id);
                    if(formful_personalization_shape_files_input)
                        copyInputFiles(getPersonalizationShapeFileInput(), formful_personalization_shape_files_input);

                    let formful_personalization_pattern_description_field = document.getElementById('field-' + personalization_pattern_description_field_id);
                    if(formful_personalization_pattern_description_field)
                        formful_personalization_pattern_description_field.value = getPersonalizationPatternTextareaElement().value;

                    let formful_personalization_pattern_files_input = document.getElementById('field-' + personalization_pattern_files_field_id);
                    if(formful_personalization_pattern_files_input)
                        copyInputFiles(getPersonalizationPatternFileInput(), formful_personalization_pattern_files_input);

                    let formful_form_realization_time_input = document.getElementById('field-' + realization_time_field_id);
                    if(formful_form_realization_time_input)
                        formful_form_realization_time_input.value = getSelectedRealizationTimeName();

                    // 2️⃣ Tymczasowo odłączamy tego listenera, żeby nie tworzyć pętli
                    submit_button.removeEventListener('click', preClickHandler);

                    // 3️⃣ Wywołujemy kliknięcie programowo, żeby pozostałe eventy się odpaliły
                    submit_button.click();

                    // 4️⃣ Przywracamy listener
                    submit_button.addEventListener('click', preClickHandler);

                    // 5️⃣ Zatrzymujemy dalsze wykonywanie w tym zdarzeniu, żeby nie dublować
                    e.stopImmediatePropagation();
                });

            }



        }
        else
            throw "Nie znaleziono formularza Formful o id = " + formful_form_id;

    }

    function getPersonalizationPatternFileInput()
    {
        return document.getElementById('personalization_pattern_file_input');
    }

    function getPersonalizationPatternFilesList()
    {
        return document.getElementById('personalization_pattern_files_list');
    }

    function getPersonalizationShapeFileInput()
    {
        return document.getElementById('personalization_shape_file_input');
    }

    function getPersonalizationShapeFilesList()
    {
        return document.getElementById('personalization_shape_files_list');
    }

    function initPersonalizationPattern()
    {
        let checkbox = getPersonalizationPatternCheckboxElement();
        if(checkbox)
        {
            checkbox.checked = false;
            checkbox.addEventListener('click', () => {
                document.getElementById('personalization_pattern_params').hidden = !isPersonalizationPatternOn();
                updatePersonalizationInfo();

                if(!isPersonalizationPatternOn())
                {
                    getPersonalizationPatternTextareaElement().value = "";
                    const container = getPersonalizationPatternFilesList();
                    container.querySelectorAll('button').forEach(button => button.click());
                }

            });

            initPersonalizationFiles(getPersonalizationPatternFileInput(), getPersonalizationPatternFilesList());
        }

    }

    function initPersonalizationShapeFiles()
    {
        let checkbox = getPersonalizationShapeCheckboxElement();
        if(checkbox)
        {
            checkbox.checked = false;
            checkbox.addEventListener('click', () => {
                document.getElementById('personalization_shape_params').hidden = !checkbox.checked;
                getSendValuationFormFormfulSection().hidden = !isPersonalizationShapeOn();
                getSubmitFormButton().hidden = isPersonalizationShapeOn();
                getCostEstimateElement().hidden = isPersonalizationShapeOn();

                updatePersonalizationInfo();

                if(!isPersonalizationShapeOn())
                {
                    getPersonalizationShapeTextareaElement().value = "";
                    const container = getPersonalizationShapeFilesList();
                    container.querySelectorAll('button').forEach(button => button.click());
                }

            });

            initPersonalizationFiles(getPersonalizationShapeFileInput(), getPersonalizationShapeFilesList());
        }

    }

    function initPersonalizationFiles(fileInput, fileListContainer)
    {

        let selectedFiles = [];

        fileInput.addEventListener('change', () => {
            const newFiles = Array.from(fileInput.files);

            if (newFiles.length === 0) {
                return;
            }

            if (fileInput.multiple) {
                // 🔹 Jeśli input ma "multiple" — doklejaj nowe pliki bez duplikatów
                newFiles.forEach(f => {
                    const exists = selectedFiles.some(sf =>
                        sf.name === f.name &&
                        sf.size === f.size &&
                        sf.lastModified === f.lastModified
                    );
                    if (!exists) {
                        selectedFiles.push(f);
                    }
                });
            } else {
                // 🔹 Jeśli NIE ma "multiple" — zawsze tylko jeden plik
                selectedFiles = newFiles.slice(0, 1);
            }

            updateFileInput(selectedFiles);
            renderFileList();
        });

        function renderFileList() {
            fileListContainer.innerHTML = '';

            selectedFiles.forEach(file => {
                const item = document.createElement('div');
                item.classList.add('file-item');

                const name = document.createElement('span');
                name.classList.add('file-name');
                name.textContent = file.name;
                item.appendChild(name);

                const removeBtn = document.createElement('button');
                removeBtn.type = 'button';
                removeBtn.textContent = '×';
                removeBtn.addEventListener('click', () => {
                    selectedFiles = selectedFiles.filter(f => f !== file);
                    updateFileInput(selectedFiles);
                    renderFileList();
                });

                item.appendChild(removeBtn);
                fileListContainer.appendChild(item);
            });
        }

        function updateFileInput(files) {
            const dt = new DataTransfer();
            files.forEach(f => dt.items.add(f));
            fileInput.files = dt.files;
        }

    }

    function updatePersonalizationInfo()
    {

        let are_dimensions_over_recommended = isPhotoEditorOn() ? PhotoEditor.areDimensionsOverRecommended() : false;
        let is_scale_over_recommended = isPhotoEditorOn() ? PhotoEditor.isScaleOverRecommended() : false;
        let is_personalization_pattern_on = isPersonalizationPatternOn();
        let is_personalization_shape_on = isPersonalizationShapeOn();

        let personalization_info_container = document.getElementById('personalization_info_container');
        if(personalization_info_container)
            personalization_info_container.hidden = !(are_dimensions_over_recommended || is_scale_over_recommended || is_personalization_pattern_on || is_personalization_shape_on);

        let personalization_info_cropping = document.getElementById('personalization_info_cropping');
        if(personalization_info_cropping)
            personalization_info_cropping.hidden = !(are_dimensions_over_recommended || is_scale_over_recommended || is_personalization_pattern_on || is_personalization_shape_on);

        let personalization_info_pattern = document.getElementById('personalization_info_pattern');
        if(personalization_info_pattern)
            personalization_info_pattern.hidden = !(is_personalization_pattern_on || is_personalization_shape_on);

        let personalization_info_valuation_request = document.getElementById('personalization_info_valuation_request');
        if(personalization_info_valuation_request)
            personalization_info_valuation_request.hidden = !(is_personalization_shape_on);


    }

    function copyInputFiles(source_file_input, target_file_input)
    {

        const dt = new DataTransfer();

        // dodaj każdy plik z input1 do nowego FileList
        for (const file of source_file_input.files) {
            dt.items.add(file);
        }

        // przypisz nową listę do drugiego inputa
        target_file_input.files = dt.files;
    }

    function initProductQuantity()
    {
        let product_quantity_input = document.querySelector('input[name="product_quantity"]');
        let data_quantity_input = document.querySelector('[data-quantity-input]');

        if(product_quantity_input && data_quantity_input)
        {
            product_quantity_input.addEventListener('change', function(_product_quantity_input) {
                if(data_quantity_input.value !== this.value)
                {
                    data_quantity_input.value = this.value;
                    updatePrice();
                }
            })

            data_quantity_input.value = product_quantity_input.value;

        }

    }

    function initDownloadTexture()
    {
        let download_texture_buttons = document.querySelectorAll('.download-texture-btn');
        if (download_texture_buttons) {
            download_texture_buttons.forEach(function (__download_texture_button){
                __download_texture_button.addEventListener('click', function() {
                    const textureUrl = __download_texture_button.dataset.textureUrl;
                    if (textureUrl) {
                        downloadTexture(__download_texture_button);
                    } else {
                        alert('Brak dostępnej tekstury dla tego produktu');
                    }
                });
            });
        }
    }

    function initAddToFavorites()
    {
        // Wishlist functionality
        let wishlist_buttons = document.querySelectorAll('.wishlist-btn');
        if (wishlist_buttons) {
            wishlist_buttons.forEach(function(__wishlist_button){
                __wishlist_button.addEventListener('click', function() {
                    const productId = __wishlist_button.dataset.productId;

                    // Sprawdź czy produkt jest już w wishlist (localStorage)
                    let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

                    if (wishlist.includes(productId)) {
                        // Usuń z wishlist
                        wishlist = wishlist.filter(id => id !== productId);
                        __wishlist_button.classList.remove('added');
                    } else {
                        // Dodaj do wishlist
                        wishlist.push(productId);
                        __wishlist_button.classList.add('added');
                    }

                    localStorage.setItem('wishlist', JSON.stringify(wishlist));

                    // Opcjonalnie: wyślij do serwera
                    // fetch('/cart/add.js', { method: 'POST', ... })
                });

                // Sprawdź stan przy załadowaniu strony
                const productId = __wishlist_button.dataset.productId;
                const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
                if (wishlist.includes(productId)) {
                    __wishlist_button.classList.add('added');
                }
            });

        }
    }

    function initShare()
    {
        let share_buttons = document.querySelectorAll('.share-btn');
        if (share_buttons) {
            share_buttons.forEach(function(__share_button){
                __share_button.addEventListener('click', function() {
                    //todo
                });
            });
        }
    }

    function initWallpaperConfigurator()
    {

        let init = function(
            product_configuration_box_id,
            product_configuration_mobile_id,
            product_configuration_mobile_unchecked_id,
            product_configuration_mobile_checked_id
        )
        {
            let open_css_class_name = "open";
            let product_configuration_box = document.getElementById(product_configuration_box_id);

            let is_editor_box = (product_configuration_box_id === 'product_crop_box');

            let product_configuration_mobile = document.getElementById(product_configuration_mobile_id);
            if(product_configuration_mobile)
            {
                let product_configuration_mobile_unchecked = document.getElementById(product_configuration_mobile_unchecked_id);
                let product_configuration_mobile_checked = document.getElementById(product_configuration_mobile_checked_id);

                product_configuration_mobile.addEventListener('click', function() {
                    let is_open = product_configuration_mobile.classList.contains(open_css_class_name);
                    if(is_open)
                    {
                        if(!Custom.hasInvalidElements(product_configuration_box))
                        {
                            product_configuration_mobile.classList.remove(open_css_class_name);
                            Custom.hideElement(product_configuration_box);
                            Custom.hideElement(product_configuration_mobile_unchecked);
                            Custom.showElement(product_configuration_mobile_checked);
                        }
                    }
                    else
                    {
                        product_configuration_mobile.classList.add(open_css_class_name);
                        Custom.showElement(product_configuration_box);

                        if(is_editor_box)
                            PhotoEditor.getEditor().redrawNow();

                        Custom.hideElement(product_configuration_mobile_checked);
                        Custom.showElement(product_configuration_mobile_unchecked);
                    }
                });
            }
            else
            {
                if(product_configuration_box)
                    Custom.showElement(product_configuration_box);
            }
        }

        init(
            'product_configuration_box',
            'product_configuration_mobile',
            'product_configuration_mobile_unchecked',
            'product_configuration_mobile_checked'
        );

        init(
            'product_crop_box',
            'product_crop_mobile',
            'product_crop_mobile_unchecked',
            'product_crop_mobile_checked'
        );

    }

    function initMobile()
    {
        if(Custom.isMobile())
        {
            let thumbnails_slider_desktop = document.querySelector(".thumbnails-slider");
            let thumbnails_slider_mobile = document.querySelector(".thumbnails_slider_mobile");

            if(thumbnails_slider_desktop && thumbnails_slider_mobile)
                thumbnails_slider_mobile.replaceWith(thumbnails_slider_desktop);

            let product_attributes_desktop = document.querySelector(".product-attributes");
            let product_attributes_mobile = document.querySelector(".product-attributes-mobile");

            if(product_attributes_desktop && product_attributes_mobile)
                product_attributes_mobile.replaceWith(product_attributes_desktop);
        }

    }

    function getPhotoEditorConfig()
    {
        return JSON.parse(document.getElementById('photo-editor-config').textContent);
    }

    function getScaledTextureUrl()
    {
        let config = getPhotoEditorConfig();
        return config.texture_file_url;
    }


    function getProductId()
    {
        return window.meta?.product?.id;
    }

    function init()
    {
        initMediaCarousel();
        initProductQuantity();
        initAddToFavorites();
        initShare();
        initWallpaperConfigurator();
        initGrayscaleButton();
        Custom.initDropdowns();
        Custom.initSliders();
        initM2TotalObserver();
        initAddToCartButton();
        initChooseMaterialPopup();
        initChooseColor();
        initChooseVariant();
        initSendValuationRequestForm();
        initPersonalizationPattern();
        initPersonalizationShapeFiles();

        Custom.initToolTips();

        initDownloadTexture();

        initMobile();


    }

    return {
        init: init,
        getPhotoEditorConfig: getPhotoEditorConfig,
        getScaledTextureUrl: getScaledTextureUrl,
        updateTilingSettings: updateTilingSettings,
        selectRealizationTime: selectRealizationTime,
        getWidthElement: getWidthElement,
        getHeightElement: getHeightElement,
        getScaleElement: getScaleElement,
        getPersonalizationShapeCheckboxElement: getPersonalizationShapeCheckboxElement,
        getPersonalizationPatternCheckboxElement: getPersonalizationPatternCheckboxElement,
        updatePersonalizationInfo: updatePersonalizationInfo,
        updatePrice: updatePrice,
        openPreviewModal: openPreviewModal,
        closePreviewModal: closePreviewModal,
        downloadPreview: downloadPreview,
    }
})();